import { type AnnotationOptions } from "chartjs-plugin-annotation";

import {
  makeFont,
  formattedSampleDates,
  getOutOfYAdjustmentSampleStartTime,
  getInSampleLabelPosition,
  getOutOfSampleLabelPosition,
  getOutOfSampleXValue,
} from "./annotation-helpers";

export const inSampleAnnotations: Record<string, AnnotationOptions> = {
  inSampleLabel: {
    type: "label",
    position: getInSampleLabelPosition,
    xValue: (ctx) => ctx.chart.scales.x.min,
    yValue: (ctx) => ctx.chart.scales.y.max,
    content: "IN SAMPLE",
    font: makeFont(),
    color: "rgb(20, 20, 20)",
  },
  inSampleDateRange: {
    type: "label",
    position: getInSampleLabelPosition,
    xValue: (ctx) => ctx.chart.scales.x.min,
    yValue: (ctx) => ctx.chart.scales.y.max,
    yAdjust: (ctx) => 16,
    content: formattedSampleDates("inSampleData"),
    font: makeFont({
      size: 10,
      weight: "normal",
    }),
    color: "rgb(20, 20, 20)",
  },
};

export const outOfSampleAnnotations: Record<string, AnnotationOptions> = {
  outOfSampleLabel: {
    type: "label",
    position: getOutOfSampleLabelPosition,
    xValue: getOutOfSampleXValue,
    yValue: (ctx) => ctx.chart.scales.y.max,
    content: "OUT OF SAMPLE",
    yAdjust: getOutOfYAdjustmentSampleStartTime,
    font: makeFont(),
    color: "rgb(20, 20, 20)",
  },
  outOfSampleDateRange: {
    type: "label",
    position: getOutOfSampleLabelPosition,
    xValue: getOutOfSampleXValue,
    yValue: (ctx) => ctx.chart.scales.y.max,
    // @ts-ignore
    yAdjust: (ctx) => getOutOfYAdjustmentSampleStartTime(ctx) + 16,
    content: formattedSampleDates("outOfSampleData"),
    font: makeFont({
      size: 10,
      weight: "normal",
    }),
    color: "rgb(20, 20, 20)",
  },
  outOfSampleRangeBox: {
    yScaleID: "y",
    xScaleID: "x",
    borderColor: "rgba(0, 0, 0, 0)",
    type: "box",
    xMin: getOutOfSampleXValue,
    xMax: (ctx) => ctx.chart.scales.x.max,
    yMin: (ctx) => ctx.chart.scales.y.min,
    backgroundColor: "rgba(112, 129, 255, 0.05)",
  },
  outOfSampleRangeLine: {
    yScaleID: "y",
    xScaleID: "x",
    borderColor: "rgb(20, 20, 20)",
    borderWidth: 1,
    type: "line",
    xMin: getOutOfSampleXValue,
    xMax: getOutOfSampleXValue,
    yMin: (ctx) => ctx.chart.scales.y.min,
  },
};
